import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { confirm } from "../../../Layout/Dialog/ConfirmDialog";
import OpeningTime, { defaultOpeningTime } from "../../../OpeningTimes/OpeningTime";
import { SmallAddButton } from "../../../Layout/Buttons/SmallAddButton";
import { BorderedGridItemWithMessage } from "../../../Grid/BorderedGridItemWithMessage";
import { OpeningTimesFormProps } from "../../../OpeningTimes/OdcFormProps";
import { useFetchPlantOpeningTimes } from "../../Hooks/useFetchPlantOpeningTimes";
import { useDeletePlantOpeningTime } from "../../Hooks/useDeletePlantOpeningTime";
import { PlantSingleOpeningTimeForm } from "./PlantSingleOpeningTimeForm";
import { useIsUserInRoles } from "../../../Auth/useIsUserInRoles";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

export const PlantOpeningTimesParentForm = ({ parentId }: OpeningTimesFormProps) => {
  const [addedOpeningTimes, setAddedOpeningTimes] = useState<OpeningTime[]>([]);

  const {
    data: existingOpeningTimes,
    isLoading: isLoadingOpeningTimes,
    isSuccess: openingTimesLoaded,
    refetch: refetchOpeningTimes,
  } = useFetchPlantOpeningTimes(parentId);

  const addOpeningTime = (newOpeningTime: OpeningTime) => {
    setAddedOpeningTimes((current) => [newOpeningTime, ...current]);
  };

  const [queryResult, setQueryResult] = useState<string>("");
  useEffect(() => {
    if (isLoadingOpeningTimes) setQueryResult("Loading opening times for Plant ...");
  }, [isLoadingOpeningTimes]);

  useEffect(() => {
    if (existingOpeningTimes) {
      setQueryResult("No Opening Times exist for this Plant yet");
    }
  }, [existingOpeningTimes, openingTimesLoaded]);

  const { mutateAsync: deleteOpeningTime } = useDeletePlantOpeningTime();

  const deleteOpeningTimeWithToast = async (openingTime: OpeningTime) => {
    if (await confirm("Do you really want to delete the current opening time?")) {
      await deleteOpeningTime(openingTime).then(async () => refetchOpeningTimes());
    }
  };

  const concatenatedOpeningTimes = [...addedOpeningTimes].concat(existingOpeningTimes ?? []);

  const isUserInAdminNetworkRole = useIsUserInRoles(AuthorizationPolicies.RequireAdminNetworkRoles);
  return (
    <>
      <SmallAddButton
        onClick={() => addOpeningTime({ ...defaultOpeningTime, ParentId: parentId } as OpeningTime)}
        disabled={
          !isUserInAdminNetworkRole || isLoadingOpeningTimes || addedOpeningTimes.length !== 0
        }
      />

      <Grid item xs={12} container justifyContent="center">
        {concatenatedOpeningTimes.length === 0 ? (
          <BorderedGridItemWithMessage message={queryResult} />
        ) : (
          concatenatedOpeningTimes.map((openingTime) => (
            <Grid item xs={12}>
              <PlantSingleOpeningTimeForm
                key={openingTime.Id}
                initialValues={openingTime}
                deleteOpeningTimeHandler={deleteOpeningTimeWithToast}
                removeOpeningTimeFromParentStateAfterSave={() => setAddedOpeningTimes([])}
              />
            </Grid>
          ))
        )}
      </Grid>
    </>
  );
};
